<template>
    <div class="content-box">
      <div class="element-wrapper">
        <div class="element-box noBoxes">
          <div :class="currentNivel.estatus ? 'row blue_gradient_bg shadow noBoxes shadow_inset' : 'row red_gradient_bg shadow noBoxes shadow_inset'">
            <div class="col-12 pt-4 px-4">
              <button 
                class="btn btn-sm btn-primary" 
                @click="$router.push({
                  name: 'cat-seccion-bodega-id',
                  params: { idSeccion: currentSection.id },
                  props: { bodegaObj: currentBodega }
                })"
              >
                <i class="fas fa-angle-double-left"></i>
                Volver a Sección
              </button>
            </div>
            <div class="position-relative noBoxes">
              <!-- <i class="fas fa-pallet bgIcons"></i> -->
              <!-- <i class="fas fa-boxes bgIcons"></i> -->
              <i class="fas fa-layer-group bgIcons"></i>
            </div>
            <div class="col-12 pb-4 pt-2 px-4">
              <h5 class="font-weight-bold pt-3" style="color: #888; padding-bottom: 0px; margin-bottom: 0px;">
                Información de Nivel:
              </h5>
              <h2 class="font-weight-bold text-white">
                {{ currentNivel.descripcion }}
                <div v-if="currentNivel.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                <div v-if="!currentNivel.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip"></div>
              </h2>
              
            </div>
          </div>
          <div class="row mt-4 px-4 justify-content-center">
            <div class="col-sm-12 col-md-4 mt-3">
              <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
                <h6 class="font-weight-bold text-dark">
                  Tienda
                </h6>
                <h5>
                  {{ currentTienda.nombre }}
                </h5>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 mt-3">
              <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
                <h6 class="font-weight-bold text-dark">
                  Pertenencia
                </h6>
                <h5>
                  {{ currentRack.rack }} - {{ currentRack.descripcion }}
                </h5>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 mt-3">
              <div class="text-center text-secondary white_gradient_bg py-3 shadow_inset rounded_pill">
                <h6 class="font-weight-bold text-dark">
                  Identidad
                </h6>
                <h5>
                  {{ currentNivel.nivel }}
                </h5>
              </div>
            </div>
          </div>
          <div v-if="currentNivel" class="row px-4 pb-3 pt-5">
            <div class="col-12 d-flex flex-wrap justify-content-center">
                <div style="text-align: right">
                  <button class="btn btn-md btn-info text-white" @click="editClickNivel(currentNivel)">
                    <i class="fa fa-edit"></i>
                    Editar Nivel
                  </button>
                  <router-link 
                    v-if="currentNivel.estatus" 
                    class="btn btn-md btn-success" 
                    :to="{ 
                      name: 'cat-position-nuevo', 
                      params: { valueForm: 'PS', actionForm: 'add', idAntecesor: currentNivel.id } 
                    }">
                    <i class="fa fa-plus"></i>
                    Asignar Posición
                  </router-link>
                </div>
              </div>
          </div>
          <div class="row px-5 py-3">
            <div class="col-12 border-bottom mb-3"></div>
            <div class="col-12 d-flex flex-wrap justify-content-center">
              <h2 class="font-weight-bold text-success">
                Posiciones
              </h2>
            </div>
            <div class="col-12 border-bottom mt-3"></div>
          </div>
          <div class="row px-4 d-flex flex-wrap justify-content-center mb-2">
            <div class="col-sm-12 col-md-4 flex-wrap justify-content-center mt-3">
              <input 
                class="form-control rounded bright w-100 text-center" 
                placeholder="Barra Posición" 
                :value="currentFilter.barra ? currentFilter.barra : ''"
                @input="currentFilter.barra = $event.target.value || null"
                type="text" 
              />
            </div>
            <div class="col-sm-12 col-md-4 flex-wrap justify-content-center mt-3">
              <input 
                class="form-control rounded bright w-100 text-center" 
                placeholder="Identidad Posición" 
                :value="currentFilter.posicion ? currentFilter.posicion : ''"
                @input="currentFilter.posicion = $event.target.value || null"
                type="text" 
              />
            </div>
          </div>
          <div class="row px-4 d-flex flex-wrap justify-content-center">
            <div v-if="listadoTiposPosiciones" class="col-sm-12 col-md-4 flex-wrap justify-content-center mt-3">
              <select v-model="currentFilter.tipo_posicion" class=" text-muted custom-select custom-select-md form-control rounded bright w-100 text-center">
                <option selected :value="null">Tipo De Posición</option>
                <option v-for="(item,index) in listadoTiposPosiciones" :key="index" :value="item.llave">{{item.valor}}</option>
              </select>
            </div>
            <div class="col-sm-12 col-md-4 flex-wrap justify-content-center mt-3">
              <select v-model="currentFilter.estatus"  class=" text-muted custom-select custom-select-md form-control rounded bright w-100 text-center">
                <option selected :value="null">Estado</option>
                <option value="1">Activo</option>
                <option value="0">Inactivo</option>
              </select>
            </div>
          </div>
          <div class="row px-4 pt-4 d-flex flex-wrap justify-content-center align-items-center">
            <div class="col-6 col-md-2">
              <div class="form-check d-flex align-items-center pb-4">
                <input class="form-check-input" type="checkbox" v-model="currentFilter.predeterminada" id="chkPredeterminada" :true-value="true" :false-value="null">
                <label class="form-check-label" for="chkPredeterminada">Predeterminada</label>
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-check d-flex align-items-center pb-4">
                <input class="form-check-input" type="checkbox" v-model="currentFilter.para_venta" id="chkParaVenta" :true-value="true" :false-value="null">
                <label class="form-check-label" for="chkParaVenta">Para Venta</label>
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-check d-flex align-items-center pb-4">
                <input class="form-check-input" type="checkbox" v-model="currentFilter.transitoria" id="chkTransitoria" :true-value="true" :false-value="null">
                <label class="form-check-label" for="chkTransitoria">Transitoria</label>
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-check d-flex align-items-center pb-4">
                <input class="form-check-input" type="checkbox" v-model="currentFilter.para_inconsistencias" id="chkInconsistencias" :true-value="true" :false-value="null">
                <label class="form-check-label" for="chkInconsistencias">Para Inconsistencias</label>
              </div>
            </div>
            <div class="col-6 col-md-2">
              <div class="form-check d-flex align-items-center pb-4">
                <input class="form-check-input" type="checkbox" v-model="currentFilter.para_contenedor" id="chkContenedor" :true-value="true" :false-value="null">
                <label class="form-check-label" for="chkContenedor">Para Contenedor</label>
              </div>
            </div>
          </div>
          <div class="row px-4 d-flex flex-wrap justify-content-center align-items-center">
            <div class="col-12 d-flex flex-wrap justify-content-center mt-3">
              <div class="input-group-append">
                <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" v-on:click="search">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" type="button" v-on:click="clearFilterData">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="col-12 border-bottom mt-3"></div>
          </div>
          <div class="row px-4">
            <div class="col-12 d-flex justify-content-center mt-5">
              <div class="input-group-append">
                <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
              </div>
            </div>
          </div>
          <PosicionesCardsComponent 
            :currentPosiciones="data.results"
            @postionEditItem="handlePostionEditItem"
          />
          <div class="row px-4 pb-5">
            <div class="col-12 d-flex justify-content-center mt-5">
              <div class="input-group-append">
                <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import BodegaSeccionService from "@/services/catalogos/BodegaSeccionService";
  import TiendaBodegaService from "@/services/catalogos/TiendaBodegaService";
  import TiendaService from "@/services/catalogos/TiendaService";
  import SeccionRackService from "@/services/catalogos/SeccionRackService";
  import RackNivelService from "@/services/catalogos/RackNivelService";
  import NivelPosicionService from "@/services/catalogos/NivelPosicionService";
  import PosicionesCardsComponent from "@/components/cat/posiciones-utils/PosicionesCardsComponent";
  import PaginationComponent from "@/components/utils/PaginationComponent";
  import DynamicService from "@/services/commons/DynamicService";
  
  export default {
    components: {
      PaginationComponent,
      PosicionesCardsComponent,
    },
    data() {
      return {
        nivelId: 0,
        listadoTiposPosiciones: {},
        currentTienda: {},
        currentBodega: {},
        currentSection: {},
        currentRack: {},
        currentNivel: {},
        currentPosiciones: {},
        current: {},
        postionEditItem: null,
        currentPage: 1,
        data: [],
        currentParams: {},
        currentFilter: {
          barra: null,
          posicion: null,
          tipo_posicion: null,
          estatus: null,  
          predeterminada: null,
          para_venta: null,
          transitoria: null,
          para_inconsistencias: null,
          para_contenedor: null
        }
      };
    },
    computed: {},
    watch: {
      postionEditItem(newValue) {
        this.editClickPosicion(newValue)
      }
    },
    mounted() {
      DynamicService.getActionList(
        "cat",
        "tienda-posicion",
        "lista_tipo_posicion"
      ).then((response) => {
        this.listadoTiposPosiciones = response.data;
        console.log(this.listadoTiposPosiciones)
      });
      /** lista_tipo_posicion
       * Fragmento necesario para poder setear
       * data de la sección actual mostrandose 
       * en la GUI
       */
      if (this.$route.params.idNivel) {
        this.nivelId = this.$route.params.idNivel;
        console.log("SeccionId: ", this.$route.params.idNivel);
        this.getCurrentNivel(this.nivelId);
      }
    },
    methods: {
      search() {
        console.log(this.currentFilter.barra)
        this.getPosiciones({
          nivel: this.nivelId,
          page: this.currentPage,
          tienda: this.currentTienda.codigo,
          ...this.currentFilter
        });
      },

      clearFilterData() {
        this.currentPage = 1;
        this.currentFilter = {
          barra: null,
          posicion: null,
          tipo_posicion: null,
          estatus: null,  
          predeterminada: null,
          para_venta: null,
          transitoria: null,
          para_inconsistencias: null,
          para_contenedor: null
        }
        this.getPosiciones({
          nivel: this.nivelId,
          page: this.currentPage,
          tienda: this.currentTienda.codigo,
          ...this.currentFilter
        });
      },

      onPageChange(page) {
        this.currentPage = page;
        this.getPosiciones({
          nivel: this.nivelId,
          page: this.currentPage,
          tienda: this.currentTienda.codigo,
          ...this.currentFilter
        });
      },

      handlePostionEditItem(item) {
        this.postionEditItem = item;
      },

      getPosiciones(params) {
        let self = this;
        NivelPosicionService.fetch(params).then((response) => {
          self.data = response.data;
          console.log("PosicionesObj: ",self.data);
        });
      },

      /**
       * Método que obtiene el nivel actual según el ID
       * recibido como parametro de url
       */
      getCurrentNivel(nivelID) {
        let self = this;
        RackNivelService.getById(nivelID).then((response) => {
          self.currentNivel = response.data;
          console.log("NivelObj: ",self.currentNivel);
          self.getRack(self.currentNivel.rack);
          self.onPageChange(1);
        });
      },

      /**
       * Método que obtiene la data del rack al que esta asignado
       * el Nivel actual.
       */
      getRack(rackID) {
        let self = this;
        SeccionRackService.getById(rackID).then((response) => {
          self.currentRack = response.data;
          console.log("RackObj: ", self.currentRack);
          self.getSeccion(self.currentRack.seccion);
        });
      },

      /**
       * Método que obtiene la Sección a la que está asignado
       * el Rack actual
       */
       getSeccion(seccionID) {
        let self = this;
        BodegaSeccionService.getById(seccionID).then((response) => {
          self.currentSection = response.data;
          console.log("SeccionObj: ",self.currentSection)
          self.getBodega(self.currentSection.bodega);
        });
      },

      /**
       * Método que obtiene la data de la Bodega
       * a la que esta asignada la Sección actual
       */
      getBodega(bodegaID) {
        let self = this;
        TiendaBodegaService.getById(bodegaID).then((response) => {
          self.currentBodega = response.data;
          console.log("BodegaObj: ", self.currentBodega);
          self.getTienda(self.currentBodega.tienda);
        });
      },
  
      /**
       * Método que obtiene la data de la tienda a la que pertenece
       * la Bodega actual
       */
      getTienda(tiendaID) {
        let self = this;
        TiendaService.getById(tiendaID).then((response) => {
          self.currentTienda = response.data;
          console.log("TiendaObj: ",self.currentTienda);
        });
      },
  
      /**
       * Método que nos sirve para accionar el botón
       * Editar Sección
       */
      editClickNivel() {
        let self = this;
        if (event.ctrlKey) {
          let routeUrl = self.$router.resolve({
            name: "cat-position-editar",
            params: { 
              valueForm: 'NV', 
              actionForm: 'edit', 
              idCurrent: self.currentNivel.id
            } 
          });
          window.open(routeUrl.href, "_blank");
        } else {
          self.$router.push({
            name: "cat-position-editar",
            params: { 
              valueForm: 'NV', 
              actionForm: 'edit', 
              idCurrent: self.currentNivel.id
            }
          });
        }
      },
  
      /**
       * Método que nos sirve para accionar el botón
       * Editar la Posición
       */
       editClickPosicion(item) {
        let self = this;
        if (event.ctrlKey) {
          let routeUrl = self.$router.resolve({
            name: "cat-position-editar",
            params: { 
              valueForm: 'PS', 
              actionForm: 'edit', 
              idCurrent: item.id
            } 
          });
          window.open(routeUrl.href, "_blank");
        } else {
          self.$router.push({
            name: "cat-position-editar",
            params: { 
              valueForm: 'PS', 
              actionForm: 'edit', 
              idCurrent: item.id
            }
          });
        }
      },
    }
  }
  </script>